export default __webpack_public_path__ + "web/react/components/app-download-banner-desktop/images/lyst_app_mobile_screen.21c6257eeff66defe0a2072314d1e39a.png";